import React, { useCallback, useState, useEffect } from "react";

import { useDispatch } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import "./DeleteAccountVerifications.css";
import OtpInput from "react-otp-input";
import { GoogleReCaptcha } from "react-google-recaptcha-v3";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import axios from "axios";
import apiServices from "../../services/apiServices";
import generateDeviceId from "../BuzzCom/utils/generateDeviceId";
import { toast, ToastContainer } from "react-toastify";
import { resendnewdeleteaccountemailotp } from "../../Store/Auth/actions";

const DeleteAccountVerification = () => {
  const { executeRecaptcha } = useGoogleReCaptcha();

  const [token, setToken] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const [otp, setOtp] = useState("");
  const [isVisible, setVisible] = useState(false);
  const [isActive, setIsActive] = useState(false);
  const [authToken, setAuthToken] = useState("");
  const [isLoadingresend, setIsLoadingresend] = useState(false);
  const [time, setTime] = useState(110); // Initial time in seconds

  const dispatch = useDispatch();

  const userid = JSON.parse(localStorage.getItem("user"))?.id;

  const { email } = useParams();
  const history = useHistory();

  const Logout = async () => {
    const confirmed = window.confirm(
      "Are you sure you want to logout from buzzcom?"
    );
    if (confirmed) {
      const deviceId = await generateDeviceId();
      const response = JSON.parse(localStorage.getItem("user"));
      const apiPayload = {
        platform: "web",
        userId: response?.id.toString(),
        signOut: true,
        deviceId,
      };
      await apiServices.updateUserPlatform(apiPayload);
      Object.keys(localStorage).forEach((key) => {
        if (!["deviceId"].includes(key)) {
          localStorage.removeItem(key);
        }
      });

      history.push("/");
      window.location.reload();
      // dispatch(logout());

      // dispatch(addSelectedBusiness(null));
    } else {
      return;
    }
  };

  useEffect(() => {
    let interval = null;

    if (isActive) {
      interval = setInterval(() => {
        setTime((prevTime) => {
          if (prevTime === 0) {
            clearInterval(interval);
            setIsActive(false);
            return 110;
          } else {
            return prevTime - 1;
          }
        });
      }, 1000);
    } else {
      clearInterval(interval);
    }

    return () => clearInterval(interval);
  }, [isActive]);

  const handleReCaptchaVerify = useCallback(async () => {
    if (!executeRecaptcha) {
      return;
    }

    const t = await executeRecaptcha("submit");
    setToken(t);
  }, [executeRecaptcha]);

  const formatTime = () => {
    const minutes = Math.floor(time / 60);
    const seconds = time % 60;
    const formattedMinutes = String(minutes).padStart(2, "0");
    const formattedSeconds = String(seconds).padStart(2, "0");
    return `${formattedMinutes}:${formattedSeconds}`;
  };

  /////////////////////
  const handleSubmit = () => {
    setIsLoading(true);
    // Define your API URL and headers
    const apiUrl = "/otpgeneration_svc/pb/verify/otp/plexaar/";
    const headers = {
      "Content-Type": "application/json",
      // Authorization: "Bearer YOUR_ACCESS_TOKEN", // Add your authentication token if needed
    };

    // Create the data you want to send to the API
    const data = {
      otpCode: otp,
      email: email,
      userId: userid,
      deviceId: localStorage.getItem("deviceId"),
      isResetPassword: false,
      isDeleteAccount: true,
    };
    // Make the POST request
    axios
      .post(`${process.env.REACT_APP_PLEXAAR_URL}${apiUrl}`, data, {
        headers: {
          "Content-Type": "application/json",
        },
      })

      .then((response) => {
        if (response.data.code === 0) {
          setIsLoading(false);
          toast.success("Your account is deleted");
          Logout();
          history.push("/");
        } else {
          setIsLoading(false);
          toast.error(response.data.message);
        }
      })
      .catch((error) => {
        setIsLoading(false);
        toast.error(error);
      });
  };
  const resendotponcall = async () => {
    await handleReCaptchaVerify();
    if (token) {
      dispatch(
        resendnewdeleteaccountemailotp({
          email: email,
          type: 1,
          // history: history,
          // setIsLoading,
          raptchaToken: token ? token : "string",
          IsMobile: false,
          IsCrossPlatForm: false,
          IsAndroidRequest: false,

          setIsActive,
          setIsLoadingresend,
        })
      );
    }
  };

  const validateOTP = (otp) => {
    const otpRegex = /^[0-9]*$/;
    return otpRegex.test(otp);
  };

  const handleToken = useCallback((token) => {
    setAuthToken(token);
    return token;
  }, []);

  return (
    <div>
      {!authToken && <GoogleReCaptcha onVerify={handleToken} />}

      <div className="container">
        <div className="">
          <div className=" ">
            <div className="text-center ">
              <div className="alignment_vertically">
                <div className="pb-3">
                  <img
                    className="img-fluid img_plexar_width"
                    src="../images/plexaar final 2 round-15 1.png"
                    alt="no-data"
                    style={{ width: "100px", height: "100px" }}
                  />
                  <div>
                    <img
                      className="img-fluid img_plexar_width"
                      src="../images/plexaar text-22 1.png"
                      alt="no-data"
                      style={{ width: "111px", height: "46" }}
                    />
                  </div>
                </div>

                <p className="sub_heading mt-4 mb-3">
                  <span style={{ display: "inline" }}>
                    We sent verification code to{" "}
                    <b className="text-black">{email}</b>.
                  </span>
                  <br />
                  Please check your inbox and enter the code below.
                </p>
                <div className="col-md-12">
                  <div className="pt-2">
                    <div
                      className="flex-wrap"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <OtpInput
                        value={otp}
                        onChange={(otp) => setOtp(otp)}
                        // className="input_style"
                        numInputs={6}
                        renderSeparator={<span>&nbsp;&nbsp;&nbsp;</span>}
                        renderInput={(props) => (
                          <input
                            {...props}
                            style={{
                              width: "3.5em",
                              height: "47px",
                              textAlign: "center",
                            }}
                          />
                        )}
                      />
                    </div>
                    <div className="text-left">
                      {validateOTP(otp) ? null : (
                        <h6 className="warning_text">
                          Only enter numbers will not accept alphabets and
                          !@#$%^
                        </h6>
                      )}
                    </div>
                    <div className="col-md-12 px-0">
                      <div className="col-md-12 text-center">
                        <p className="mb-1 pt-4 having_problrm">
                          Having problem?
                        </p>
                        {isActive && authToken ? (
                          <p
                            onClick={resendotponcall}
                            className="mb-0 resend_button_disabled"
                          >
                            Resend Code
                          </p>
                        ) : (
                          <p
                            className="mb-0 resend_button"
                            onClick={resendotponcall}
                          >
                            Resend Code
                          </p>
                        )}
                        {isLoadingresend ? (
                          <div
                            className="spinner-border spinner-sm text-primary"
                            role="status"
                          >
                            <span className="sr-only">Loading...</span>
                          </div>
                        ) : null}

                        <p className=" having_problrm">
                          {" "}
                          {isActive ? <div>{formatTime()}</div> : null}{" "}
                        </p>
                      </div>
                    </div>
                    <div className="ps-5 pe-5 me-5 ms-5">
                      {otp.length === 6 && validateOTP(otp) ? (
                        <button
                          className="btn btn-primary button_width btn-lg"
                          // onClick={() => history.push(`/create-password`)}
                          onClick={handleSubmit}
                        >
                          {isLoading ? (
                            <div
                              className="spinner-border text-light"
                              role="status"
                            >
                              <span className="sr-only">Loading...</span>
                            </div>
                          ) : (
                            <>Verify Now</>
                          )}
                        </button>
                      ) : (
                        <button
                          className="btn btn-primary button_width_disabled button_width btn-lg"
                          // onClick={() => history.push(`/create-password`)}
                          disabled={!authToken ? false : true}
                        >
                          Verify Now
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer />
    </div>
  );
};

export default DeleteAccountVerification;
